import { render, staticRenderFns } from "./SingleGroup.vue?vue&type=template&id=673ec896&scoped=true&"
import script from "./SingleGroup.vue?vue&type=script&lang=js&"
export * from "./SingleGroup.vue?vue&type=script&lang=js&"
import style0 from "./SingleGroup.vue?vue&type=style&index=0&id=673ec896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673ec896",
  null
  
)

export default component.exports